/* A decorative edge sparkle, only while the footer link is in view. */
(() => {
  if (window.scFooterShimmerLoaded || !('IntersectionObserver' in window)) return;
  window.scFooterShimmerLoaded = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const links = new Map();
  const stop = (state) => {
    clearTimeout(state.timer);
    state.animation?.cancel();
    state.link.classList.remove('sc-shimmer-active');
  };
  const schedule = (state, delay = 12000) => {
    stop(state);
    if (!state.visible || motion.matches || document.hidden) return;
    state.timer = setTimeout(() => {
      if (!state.link.isConnected) { observer.unobserve(state.link); links.delete(state.link); return; }
      play(state);
      state.timer = setTimeout(() => schedule(state), 8000);
    }, delay);
  };
  const play = (state) => {
    const w = state.link.clientWidth, h = state.link.clientHeight;
    const r = Math.min(h / 2 - 2, 22), y = 2, bottom = h - 2;
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', `M ${r + 2} ${y} H ${w-r-2} A ${r} ${r} 0 0 1 ${w-2} ${r+2} V ${bottom-r} A ${r} ${r} 0 0 1 ${w-r-2} ${bottom} H ${r+2} A ${r} ${r} 0 0 1 2 ${bottom-r} V ${r+2} A ${r} ${r} 0 0 1 ${r+2} 2 Z`);
    const length = path.getTotalLength();
    const start = path.getPointAtLength(0);
    const origin = `translate(${start.x-5}px, ${start.y-5}px)`;
    const frames = [
      { offset: 0, transform: `${origin} scale(.35)`, opacity: 0 },
      { offset: .04, transform: `${origin} scale(.45)`, opacity: .5 },
      { offset: .15, transform: `${origin} scale(1.3)`, opacity: 1 },
    ];
    for (let i = 0; i <= 80; i++) {
      const t = i / 80;
      const point = path.getPointAtLength(length * (1 - (1-t) ** 2));
      frames.push({ offset: .18 + t * .52, transform: `translate(${point.x-5}px, ${point.y-5}px) scale(${1.3 - .65*t})`, opacity: 1 - .3*t });
    }
    for (const [offset, scale, opacity] of [[.78,.4,.35],[.87,.5,.65],[.95,.35,.3],[1,.3,0]]) {
      frames.push({ offset, transform: `${origin} scale(${scale})`, opacity });
    }
    state.link.classList.add('sc-shimmer-active');
    state.animation = state.sparkle.animate(frames, {duration: 8000, fill: 'none'});
  };
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const state = links.get(entry.target);
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.9;
      schedule(state, 2000);
    }
  }, { threshold: [0, 0.9] });
  const init = () => {
    for (const [link, state] of links) {
      if (!link.isConnected) { stop(state); observer.unobserve(link); links.delete(link); }
    }
    document.querySelectorAll('.footer .footer-block__details-content a[href="https://www.youtube.com/@Silk-Crane"]').forEach((link) => {
      if (links.has(link)) return;
      const sparkle = document.createElement('span');
      sparkle.className = 'sc-edge-sparkle';
      sparkle.setAttribute('aria-hidden', 'true');
      link.append(sparkle);
      const state = { link, sparkle, visible: false, timer: null, animation: null };
      links.set(link, state);
      link.classList.add('sc-footer-shimmer');
      observer.observe(link);
    });
  };
  const refresh = () => links.forEach((state) => schedule(state));
  motion.addEventListener('change', refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  init();
})();
